import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Save icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/floppy-disk?f=classic&s=solid
 */
export const SaveIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faFloppyDisk} {...props} />;
};
